import React from 'react';
import './styles.scss';
import { Group, Skeleton, Stack } from '@mantine/core';

const LoaderTestimony = () => {
  return (
    <div className="container-testimony-item">
      <Stack gap={10}>
        <Skeleton height={20} w={'80%'} />
        <Skeleton height={20} />
        <Skeleton height={20} />

        <Group gap={10}>
          <Skeleton height={100} w={100} radius={100} />
          <Stack gap={0}>
            <Skeleton height={16} w={'80%'} />
            <Skeleton height={16} w={'60%'} />
            <Skeleton height={16} w={'50%'} />
          </Stack>
        </Group>
      </Stack>
    </div>
  );
};

export default LoaderTestimony;
